import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRecKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRecKeyframe"><Path fillRule="evenodd" clipRule="evenodd" d="M1.18945 12.0001L12.0001 1.18945L22.8108 12.0001L12.0001 22.8108L1.18945 12.0001ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRecKeyframe;
